<div class="row-result-container">
    <div class="row-result">
        <div class="row-result-header">
            <ng-container *ngIf="row.parseStatus === 'SUCCEED' && row.validationStatus === 'SUCCEED'">
                <h3 class="text-success">
                    <i class="fa fa-check-circle"></i>
                    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.row.success', params: {rowNumber: row.rowNumber}}]"></span>
                </h3>
            </ng-container>

            <ng-container *ngIf="row.parseStatus !== 'SUCCEED' || row.validationStatus !== 'SUCCEED'">
                <h3 class="text-danger">
                    <i class="fa fa-exclamation-circle"></i>
                    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.row.fail', params: {rowNumber: row.rowNumber}}]"></span>
                </h3>
            </ng-container>

            <div class="row-result-actions">
                <button *ngIf="!valuesShown" class="btn btn-primary btn-sm" (click)="showValues()">
                    <i class="fa fa-eye"></i>
                    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.buttons.show-details'}]"></span>
                </button>
                <button *ngIf="valuesShown" class="btn btn-primary btn-sm" (click)="hideValues()">
                    <i class="fa fa-eye-slash"></i>
                    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.buttons.hide-details'}]"></span>
                </button>
            </div>
        </div>

        <div *ngIf="valuesShown" class="row-result-values">
            <ng-container *ngFor="let columnValue of columnsValue; let i = index">
                <div *ngIf="columnValue.hasError || !columnValue.collapsed || !row.failed" class="row-result-values-column"
                     [ngClass]="{ 'has-error': columnValue.hasError }">
                    <div class="row-result-values-column-header">{{columnValue.column.name}}</div>

                    <div class="row-result-values-column-value" [title]="row.rowValue[i]">
                        <ng-container *ngIf="!row.rowValue[i]">
                            <div class="empty-value" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.row.empty'}]"></div>
                        </ng-container>
                        <ng-container *ngIf="row.rowValue[i] && columnValue.hasError">
                            {{row.rowValue[i]}}
                        </ng-container>
                        <ng-container *ngIf="row.rowValue[i] && !columnValue.hasError" [ngSwitch]="columnValue.column.type">
                            <ng-container *ngSwitchCase="ColumnsTypes.ENUM">
                                <label class="label label-default">{{row.rowValue[i]}}</label>
                            </ng-container>
                            <ng-container *ngSwitchCase="ColumnsTypes.STRING">
                                <span class="string-value">{{row.rowValue[i]}}</span>
                            </ng-container>
                            <ng-container *ngSwitchCase="ColumnsTypes.NUMBER">
                                <span class="number-value">{{row.rowValue[i]}}</span>
                            </ng-container>
                            <ng-container *ngSwitchCase="ColumnsTypes.LATITUDE">
                                <span class="number-value">{{row.rowValue[i]}}</span>
                            </ng-container>
                            <ng-container *ngSwitchCase="ColumnsTypes.LONGITUDE">
                                <span class="number-value">{{row.rowValue[i]}}</span>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                {{row.rowValue[i]}}
                            </ng-container>
                        </ng-container>
                    </div>

                    <div class="row-result-values-column-error text-danger" *ngIf="columnValue.hasError">
                        <span [i18n]="[{target: 'innerHTML', key: 'columnValue.errorMessageKey'}]"></span>
                        <a [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.row.buttons.column-error-details'}]" (click)="showColumnErrorDetail(columnErrorDetailsModal, columnValue)"></a>
                    </div>
                </div>
                <div *ngIf="columnValue.collapsed && columnValue.showCollapsButton" class="row-result-values-column has-collapse-button">
                    <div class="row-result-values-column-header">&nbsp;</div>
                    <div class="row-result-values-column-value"></div>
                    <div class="collapse-button-container">
                        <span class="collapse-button" (click)="showCollapsedColumns(columnValue)">
                            <i class="fa fa-ellipsis-h"></i>
                        </span>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>



<ng-template #columnErrorDetailsModal let-c="close" let-d="dismiss" let-columnValue="columnValue">
    <div class="alert alert-danger">
        <i class="fa fa-exclamation-circle"></i> <span [i18n]="[{target: 'innerHTML', key: columnValue.errorMessageKey}]"></span>
    </div>

    <div class="column-error-details-type">
        <ng-container [ngSwitch]="columnValue.column.type">
            <span *ngSwitchCase="ColumnsTypes.STRING" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.row.modals.column-error-details.type-string'}]"></span>
            <span *ngSwitchCase="ColumnsTypes.NUMBER" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.row.modals.column-error-details.type-number'}]"></span>
            <span *ngSwitchCase="ColumnsTypes.LATITUDE" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.row.modals.column-error-details.type-latitude'}]"></span>
            <span *ngSwitchCase="ColumnsTypes.LONGITUDE" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.row.modals.column-error-details.type-longitude'}]"></span>
            <span *ngSwitchCase="ColumnsTypes.DATE" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.row.modals.column-error-details.type-date'}]"></span>
            <span *ngSwitchCase="ColumnsTypes.ENUM" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.row.modals.column-error-details.type-enum'}]"></span>
        </ng-container>
    </div>
    <div class="column-error-details-sample">
        <ng-container [ngSwitch]="columnValue.column.type">

            <ng-container *ngSwitchCase="ColumnsTypes.ENUM">
                <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.row.modals.column-error-details.sample-enum'}]"></span>
                <span *ngFor="let sample of columnValue.column.sample" class="label label-default">{{ sample }}</span>
            </ng-container>

            <ng-container *ngSwitchCase="ColumnsTypes.NUMBER">
                <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.row.modals.column-error-details.sample'}]"></span>
                <span class="number-value">{{ columnValue.column.sample }}</span>
            </ng-container>

            <ng-container *ngSwitchCase="ColumnsTypes.LATITUDE">
                <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.row.modals.column-error-details.sample'}]"></span>
                <span class="number-value">{{ columnValue.column.sample }}</span>
            </ng-container>

            <ng-container *ngSwitchCase="ColumnsTypes.LONGITUDE">
                <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.row.modals.column-error-details.sample'}]"></span>
                <span class="number-value">{{ columnValue.column.sample }}</span>
            </ng-container>

            <ng-container *ngSwitchDefault>
                <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.row.modals.column-error-details.sample'}]"></span>
                <span class="string-value">{{ columnValue.column.sample }}</span>
            </ng-container>

        </ng-container>
    </div>
</ng-template>
